module.exports = __webpack_public_path__ + "static/Graphik-Medium-Web-eb814cd0d1ed68e0c9d218f6fec91fce.woff2";